function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Cookies from "js-cookie";
export var CookiePolityce = /*#__PURE__*/function () {
  function CookiePolityce() {
    var _this = this;
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ".js-cookies";
    _classCallCheck(this, CookiePolityce);
    if (Cookies === undefined) {
      console.error("No Cookie :(");
      return;
    }
    this.els = {};
    var $els = document.querySelectorAll(selector);
    if ($els.length) {
      $els.forEach(function ($el) {
        var id = $el.id;
        _this.els[id] = {
          id: _this.cookieName(id),
          el: $el,
          hide: !!Cookies.get(_this.cookieName(id))
        };
        $el.style.overflow = "hidden";
        // $el.style.transition = 'height .5s ease';

        _this.click($el, "button", function (target, e) {
          _this[_this.els[id].hide ? "show" : "hide"](id);
        });
      });
      this.init();
    }
  }
  return _createClass(CookiePolityce, [{
    key: "cookieName",
    value: function cookieName(id) {
      return "go-popup-" + id;
    }
  }, {
    key: "click",
    value: function click(delegat) {
      var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var handler = arguments.length > 2 ? arguments[2] : undefined;
      delegat.addEventListener("click", function (e) {
        for (var target = e.target; target && target != delegat; target = target.parentNode) {
          if (selector && target.matches(selector)) {
            handler(target, e);
            break;
          }
        }
      }, false);
    }
  }, {
    key: "hide",
    value: function hide(key) {
      var popup = this.els[key];

      // console.log('hide', popup.el.getAttribute('data-share'));

      /** Set the height as 0px to trigger the slide up animation. */
      popup.el.style.height = "0px";
      Cookies.set(this.cookieName(key), true, {
        expires: 1
      });

      /** Remove the `active` class when the animation ends. */
      popup.el.addEventListener("transitionend", function () {
        popup.el.classList.remove("active");
        popup.el.hide = true;
        document.body.classList.remove(popup.id + "--active");
      }, {
        once: true
      });
    }
  }, {
    key: "show",
    value: function show(key) {
      var popup = this.els[key];
      if (!popup.hide) {
        document.body.classList.add(popup.id + "--active");
        popup.el.classList.add("active");
        popup.el.style.height = "auto";
        var height = popup.el.clientHeight + "px";
        popup.el.style.height = "0px";
        setTimeout(function () {
          popup.el.style.height = height;
        }, 0);
      }
    }
  }, {
    key: "init",
    value: function init() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (id) {
        //   console.log('toggleOne')
      } else {
        for (var _i = 0, _Object$entries = Object.entries(this.els); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            popup = _Object$entries$_i[1];
          if (popup.hide) {
            this.hide(key);
          } else {
            this.show(key);
          }
        }
      }
    }
  }]);
}();
export var vhCalc = function vhCalc() {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
};
export var docReady = function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
};
export var scrollTo = function scrollTo(element, to, duration) {
  if (duration <= 0) {
    return;
  }
  var difference = to - element.scrollTop;
  var perTick = difference / duration;
  setTimeout(function () {
    element.scrollTop = element.scrollTop + perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  }, 10);
};
export var debounce = function debounce(method, delay) {
  clearTimeout(method._tId);
  method._tId = setTimeout(function () {
    method();
  }, delay);
};
export var getAverageRGB = function getAverageRGB(imgEl) {
  var blockSize = 5,
    // only visit every 5 pixels
    defaultRGB = {
      r: 0,
      g: 0,
      b: 0
    },
    // for non-supporting envs
    canvas = document.createElement("canvas"),
    context = canvas.getContext && canvas.getContext("2d"),
    data,
    width,
    height,
    i = -4,
    length,
    rgb = {
      r: 0,
      g: 0,
      b: 0
    },
    count = 0;
  if (!context) {
    return defaultRGB;
  }
  height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
  width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;
  context.drawImage(imgEl, 0, 0);
  try {
    data = context.getImageData(0, 0, width, height);
  } catch (e) {
    /* security error, img on diff domain */alert("x");
    return defaultRGB;
  }
  length = data.data.length;
  while ((i += blockSize * 4) < length) {
    ++count;
    rgb.r += data.data[i];
    rgb.g += data.data[i + 1];
    rgb.b += data.data[i + 2];
  }

  // ~~ used to floor values
  rgb.r = ~~(rgb.r / count);
  rgb.g = ~~(rgb.g / count);
  rgb.b = ~~(rgb.b / count);
  return rgb;
};